import templateModalKjson from '~/components/oo-admin/modal/modal-kjson.html';
import ModalKjsonController from '~/components/oo-admin/modal/modal-kjson.controller';
import { createComponentInstance } from '~/components/kform/components/kform-component-class';

export default class KformTabFormController {
	/* @ngInject */
	/**
	 * @param {import('angular').IRootElementService} $element
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {import('~/scripts/services/model/user').UserModel} User
	 */
	constructor($element, $scope, $timeout, $uibModal, User) {
		this.$element = $element;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$uibModal = $uibModal;

		this.comments = [];

		this.commentOptions = {
			defaultType: 'K_NODE;KNOTECTXTYPE_perso',
			showTypes:   true,
		};

		/** @type {boolean} */
		this.disabled = true;

		/** @type {?import('~/scripts/services/model/form').default} */
		this.form = null;

		/** @type {boolean} */
		this.isAdmin = !!User.getProfil().admin;

		/** @type {?import('../kform.controller').default} */
		this.kform = null;

		this.kid = undefined;
	}

	/**
	 * @param {Event} event
	 */
	async openFormComponents(event) {
		event.preventDefault();

		const data = await this.$uibModal.open({
			template:     templateModalKjson,
			controller:   ModalKjsonController,
			controllerAs: '$ctrl',
			size:         'lg',
			resolve:      {
				label:    () => this.form?.isa?.objname,
				disabled: () => false,
				kjson:    () => this.form?.components.map(component => component.export()),
			},
		}).result;
		this.$timeout(() => {
			if (this.form) {
				this.form.components = data.kjson ? data.kjson.map(
					(/** @type {any} */ settings) => createComponentInstance(settings),
				) : [];
			}
		});
	}

	/**
	 * @param {Event} event
	 */
	async openSubmissionData(event) {
		event.preventDefault();

		try {
			const data = await this.$uibModal.open({
				template:     templateModalKjson,
				controller:   ModalKjsonController,
				controllerAs: '$ctrl',
				size:         'lg',
				resolve:      {
					label:    () => this.form?.name,
					disabled: () => false,
					kjson:    () => this.form?.exportSubmissionData(this.form.submission),
				},
			}).result;
			this.$timeout(() => {
				if (this.form?.submission) {
					this.form.submission.data = Object.fromEntries(
						// @ts-ignore
						data.kjson.map((/** @type {{ key: any; values: any; }} */ data) => [
							data.key,
							data.values
						]),
					);
				}
			});
		}
		catch { /* empty */ }
	}

	$onInit() {
		this.$element.bind('wheel', () => {
			this.$scope.$broadcast('Form.closeDatepickerPopup');
		});
	}
}
